import React from 'react';
import CrudClientes from './CrudClientes';
import { titulos, notificaciones} from './Objetos/Constantes';

const CatalogoClientes = () => {
    return (
        <>
            <CrudClientes
                titulos={titulos}
                notificaciones={notificaciones}
            />
        </>
    )
}

export default CatalogoClientes;
